"use strict";
exports.__esModule = true;
exports["default"] = (function (val) {
    return parseInt(val);
});
